import { getIncludeIconSelectGroups } from '../constants/includeIconOptions.js';
import { getIncludeIconDisplay, getIncludeSidebarLucideComponent } from '../utils/feeIncludeIcons.js';

const ALL_GROUPS = getIncludeIconSelectGroups();
const ALL_VALUES = new Set(ALL_GROUPS.flatMap((g) => g.options.map((o) => o.value)));

/**
 * Full icon <select> — all emoji groups + full Lucide list.
 * Use everywhere an icon is picked in the admin panel.
 * Supports `iconOnly` mode which displays only the icon/emoji in a compact tile.
 */
export default function FullIconSelect({ value, onChange, className, defaultLabel = 'Default', iconOnly = false }) {
  const current = value ?? '';
  const hasCurrent = current && !ALL_VALUES.has(current);

  if (iconOnly) {
    const display = getIncludeIconDisplay(current);
    const IconComponent = display.mode === 'lucide' ? getIncludeSidebarLucideComponent(display.slug) : null;

    return (
      <div className={`full-icon-select-wrapper ${className || ''}`}>
        <div className="full-icon-select-display" aria-hidden="true">
          {display.mode === 'emoji' ? (
            <span className="full-icon-select-emoji">{display.text}</span>
          ) : IconComponent ? (
            <IconComponent size={20} className="full-icon-select-icon" />
          ) : (
            <span className="full-icon-select-placeholder">?</span>
          )}
        </div>
        <select
          className="full-icon-select-control"
          value={current}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">{defaultLabel}</option>
          {hasCurrent && <option value={current}>Current: {current}</option>}
          {ALL_GROUPS.map((group) => (
            <optgroup key={group.label} label={group.label}>
              {group.options.map((opt) => (
                <option key={`${group.label}-${opt.value}`} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>
    );
  }

  return (
    <select
      className={className}
      value={current}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">{defaultLabel}</option>
      {hasCurrent && <option value={current}>Current: {current}</option>}
      {ALL_GROUPS.map((group) => (
        <optgroup key={group.label} label={group.label}>
          {group.options.map((opt) => (
            <option key={`${group.label}-${opt.value}`} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
